import { DataLinkPage } from '../../DataLink';

const DataArticle = {
  path: DataLinkPage.edu_definisiManajemenRisiko,
  preview: {
    title: [
      {
        text: 'Definisi Manajemen Risiko',
      },
    ],
    subInfo: {
      author: 'Rivo Bifa',
      linkProfile: DataLinkPage.author_rivoBifa,
      timestamp: 'Minggu, 10 April 2022',
      location: 'Jakarta',
    },
    content: [
      {
        paragraph: [
          [
            {
              text: 'Artikel ini membahas tentang definisi dari manajemen risiko menurut standar dan organisasi yang ada. Diantaranya ialah ISO 31000:2018, The Committee of Sponsoring Organization of The Treadway Commission (COSO), Komite Nasional Kebijakan Governance (KNKG), dan ERM AS/NZS 4360:1999.',
            },
          ],
        ],
      },
      // {
      //   previewArticle: DPAImage.definisiManajemenRisiko,
      // },
    ],
  },
  section: [
    {
      title: [
        {
          text: 'ISO 31000:2018',
        },
      ],
      content: [
        {
          quote: {
            content: [
              {
                text: 'Coordinated activities to direct and control an organization with regard to risk.',
                type: 'italic',
              },
            ],
            author: {
              text: 'ISO 31000:2018',
              path: 'https://www.iso.org/obp/ui/#iso:std:iso:31000:ed-2:v1:en',
            },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Definisi manajemen risiko menurut ISO 31000:2018 adalah kegiatan terkoordinasi untuk mengarahkan dan mengendalikan organisasi berkaitan dengan risiko.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'The Committee of Sponsoring Organization of The Treadway Commission (COSO)',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Definisi manajemen risiko menurut The Committee of Sponsoring Organization of The Treadway Commission (COSO) adalah suatu proses yang dipengaruhi oleh direksi, manajemen, dan pihak lain, yang diaplikasikan dalam penentuan strategi perusahaan, yang dirancang untuk mengidentifikasi risiko-risiko yang mungkin mempengaruhi perusahaan, dan mengelola risiko-risiko tersebut tetap berada pada selera risiko perusahaan, serta memberikan pemastian yang memadai bahwa tujuan perusahaan dapat dicapai.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Komite Nasional Kebijakan Governance (KNKG)',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Definisi manajemen risiko menurut Komite Nasional Kebijakan Governance (KNKG) adalah salah satu disiplin yang mengajak kita untuk secara logis, konsisten dan sistematis melakukan pendekatan terhadap ketidakpastian masa depan, sehingga memungkikan kita untuk secara lebih hati-hati (prudent) dan produktif menghindari hal-hal yang tidak berguna karena membuang sumber daya secara tidak perlu, dan mencegah hal-hal yang merugikan atau bahkan mengejar hal-hal yang bermanfaat.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'ERM AS/NZS 4360:1999',
        },
      ],
      content: [
        {
          quote: {
            content: [
              {
                text: 'Risk management is the term applied to a logical and systematic method of establishing the context, identifying, analyzing, evaluating, treating, monitoring, and communicating risks associated with any activity, function, or process in a way that will enable organizations to minimize losses and maximize opportunities.',
                type: 'italic',
              },
            ],
            author: {
              text: 'ERM AS/NZS 4360:1999',
              path: 'http://www.epsonet.eu/mediapool/72/723588/data/2017/AS_NZS_4360-1999_Risk_management.pdf',
            },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Definisi manajemen risiko menurut ERM AS/NZS 4360:1995 adalah istilah yang diterapkan pada metode logis dan sistematis untuk menetapkan konteks, mengidentifikasi, menganalisis, mengevaluasi, menangani, memantau, dan mengomunikasikan risiko yang terkait dengan aktivitas, fungsi, atau proses apa pun dengan cara yang memungkinkan organisasi meminimalkan kerugian dan memaksimalkan peluang.',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: '1.3.25 Risk management is the culture, processes and structures that are directed towards the effective management of potential opportunities and adverse effects.',
                type: 'italic',
              },
            ],
            author: {
              text: 'ERM AS/NZS 4360:1999',
              path: 'http://www.epsonet.eu/mediapool/72/723588/data/2017/AS_NZS_4360-1999_Risk_management.pdf',
            },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Dalam bagian (bab) definisi, ERM AS/NZS 4360:1999 mendifinisikan manajemen risiko sebagai budaya, proses dan struktur yang diarahkan pada pengelolaan yang efektif dari peluang potensial dan efek samping.',
              },
            ],
            [
              {
                text: 'Standar ini merupakan standar manajemen risiko pertama di dunia yang direvisi setiap lima tahun sekali agar dapat menyesuaikan dengan perkembangan zaman. Standar ini merupakan langkah awal untuk membuat suatu kerangka referensi global atas manajemen risiko.',
              },
            ],
          ],
        },
      ],
    },
  ],
  conclusion: {
    title: [
      {
        text: 'Kesimpulan',
      },
    ],
    content: [
      {
        paragraph: [
          [
            {
              text: 'Tidak ada definisi manajemen risiko yang bersifat universal, secara umum dapat dideskripsikan sebagai:',
            },
          ],
        ],
      },
      {
        list: {
          content: [
            [
              {
                text: 'Aplikasi dari prinsip-prinsip pengambilan keputusan terkait dengan risiko,',
              },
            ],
            [
              {
                text: 'Meminimalkan biaya risiko secara keseluruhan.',
              },
            ],
          ],
        },
      },
      {
        paragraph: [
          [
            {
              text: 'Namun, yang paling bermakna adalah yang menunjukan proses manajemen risiko, yaitu: identifikasi, pengukuraan, kontrol, dan biaya risiko yang dilakukan baik individu maupun organisasi terkait dengan kelangsungan hidupnya, kekayaan, pendapatan atau pelayanan yang disediakan.',
            },
          ],
        ],
      },
    ],
  },
};

export default DataArticle;
